import React from 'react';
import get from 'lodash/get';
import { ImageStyledWrapper, Image } from '@yme/atoms/image';
import { ImageErrorPlaceholder } from '@yme/atoms/image-error-placeholder';
import { getAttributeByName } from '@yme/utils/common';
import { AspectRatio } from '@yme/utils/constants';
import { getMasterVariant, getProductYear } from '@yme/utils/product';
import { MODEL_NAME, PRODUCT_INDEX_ATTRIBUTE, STUDIO_REGEXP } from './constants';
import { ImageContainerStyled } from './styled';
const getProductStudioImage = (images) => {
    if (images.length) {
        return images.find((item) => STUDIO_REGEXP.test(item?.label))?.url;
    }
    return '';
};
export const prepareProductsInRightFormat = (products) => {
    if (products.length) {
        return products.map((product) => {
            const label = `${product?.name} ${product?.slug.split('-').at(-1)}`;
            const image = getProductStudioImage(product?.variants[0]?.images);
            return {
                value: String(product?.key),
                label,
                image,
            };
        });
    }
    return [];
};
export const getIsEndOfScroll = (scrollCurrent) => {
    const scrollTopPosition = Math.round(scrollCurrent.scrollTop + scrollCurrent.clientHeight);
    return (scrollCurrent.scrollHeight === scrollTopPosition ||
        scrollCurrent.scrollHeight === scrollTopPosition + 1 ||
        scrollCurrent.scrollHeight === scrollTopPosition - 1);
};
const prepareDropdownProductImage = (image) => (React.createElement(ImageContainerStyled, null, image ? (React.createElement(ImageStyledWrapper, { isFullHeight: true },
    React.createElement(Image, { src: image, aspectRatio: AspectRatio.RectangleLevel3, objectFit: "cover" }))) : (React.createElement(ImageErrorPlaceholder, null))));
export const prepareDropdownProductData = (products) => prepareProductsInRightFormat(products).map(({ label, image, value }) => ({
    label,
    value: String(value),
    icon: prepareDropdownProductImage(image),
}));
export const findProductByKey = (products, key) => products.find((product) => product.key === key) || null;
export const getSelectYourModelModalLabels = (labels = {}) => ({
    header: get(labels, 'selectModel_popUp_header', 'selectModel_popUp_header'),
    selectModelPlaceholder: get(labels, 'selectModel_selectModel_placeholder', 'selectModel_selectModel_placeholder'),
    searchNameLabel: get(labels, 'selectModel_searchName_label', 'selectModel_searchName_label'),
    selectCategoryLabel: get(labels, 'selectModel_selectCategory_label', 'selectModel_selectCategory_label'),
    searchNameInputPlaceholder: get(labels, 'selectModel_searchNameInput_placeholder', 'selectModel_searchNameInput_placeholder'),
    searchInputNoResultsHeader: get(labels, 'selectModel_searchInputNoResults_header', 'selectModel_searchInputNoResults_header'),
    selectModelLabel: get(labels, 'selectModel_selectModel_label', 'selectModel_selectModel_label'),
    selectCategoryPlaceholder: get(labels, 'selectModel_selectCategory_placeholder', 'selectModel_selectCategory_placeholder'),
    selectYearLabel: get(labels, 'selectModel_selectYear_label', 'selectModel_selectYear_label'),
    searchTypeLabel: get(labels, 'selectModel_searchType_label', 'selectModel_searchType_label'),
    searchInputNoResultsDescription: get(labels, 'selectModel_searchInputNoResults_description', 'selectModel_searchInputNoResults_description'),
    selectYearPlaceholder: get(labels, 'selectModel_selectYear_placeholder', 'selectModel_selectYear_placeholder'),
    accessoryNotCompatible: get(labels, 'selectModel_accessoryNotCompatible_label', 'selectModel_accessoryNotCompatible_label'),
    accessoryIsCompatible: get(labels, 'selectModel_accessoryIsCompatible_label', 'selectModel_accessoryIsCompatible_label'),
});
export const sortingByProductIndex = (products) => {
    return products.sort((productA, productB) => {
        const masterVariantA = getMasterVariant(productA.variants);
        const masterVariantB = getMasterVariant(productB.variants);
        const productIndexA = masterVariantA
            ? +getAttributeByName(masterVariantA.attributes, PRODUCT_INDEX_ATTRIBUTE)
            : 0;
        const productIndexB = masterVariantB
            ? +getAttributeByName(masterVariantB.attributes, PRODUCT_INDEX_ATTRIBUTE)
            : 0;
        return productIndexA - productIndexB;
    });
};
export const sortingByCategory = ({ products, externalIds, }) => {
    if (!products?.length) {
        return [];
    }
    return externalIds.reduce((acc, externalId) => {
        const productsByCategory = products.filter((product) => {
            return product.categories.some((category) => category.published && category.key.includes(externalId));
        });
        return [...acc, ...sortingByProductIndex(productsByCategory)];
    }, []);
};
export const checkCompatibility = ({ key, suitableProductsKeys, }) => {
    return suitableProductsKeys?.length
        ? suitableProductsKeys.some((productKey) => Number(productKey) === Number(key))
        : false;
};
export const getModelName = (product) => {
    if (!product) {
        return '';
    }
    const productYear = getProductYear(product);
    return productYear ? ` ${productYear} ${product.name} ` : ` ${product.name} `;
};
export const replaceModelNameWithJSX = ({ text, jsxFragment, }) => {
    const parts = text.split(MODEL_NAME);
    if (parts.length === 1) {
        return (React.createElement(React.Fragment, null,
            text,
            jsxFragment));
    }
    return (React.createElement(React.Fragment, null, parts.map((part, index) => (React.createElement(React.Fragment, { key: index },
        part,
        index < parts.length - 1 ? jsxFragment : null)))));
};
